@if (category && category !== 'NEW') {
  <div class="sc sc_{{ category }}">
    {{ SessionCategoryLabel.get(category) + "" | translate }}
  </div>
} @else {
  <div class="sc sc_NEW">
    <mat-icon>add</mat-icon>
    {{ "trainingList.newSession" | translate }}
  </div>
}
